module.exports = __webpack_public_path__ + "static/media/sista-spinner.f4a8aa66.gif";